module.exports = __webpack_public_path__ + "img/barber_shop-600x450.7720f255.jpg";